import React from "react";
import PublicLayout from "@/components/PublicLayout";
import AboutSection from "@/components/AboutSection";

export default function About() {
  return (
    <PublicLayout>
      <section className="pt-32 md:pt-40 pb-8">
        <div className="max-w-[1500px] mx-auto px-5 md:px-10">
          <div className="eyebrow mb-4">The Studio</div>
          <h1 className="font-display italic text-5xl md:text-8xl leading-[0.95] tracking-tight max-w-3xl">
            About us.
          </h1>
        </div>
      </section>
      <AboutSection />
    </PublicLayout>
  );
}
